import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { home, system_manager } from '../../../assets/conf_urls.json';

@Injectable()

export class BulkActionsService {

  constructor(private http: HttpClient) {
  }

  bulkDelete(units: number[], userWhoMadeRequest: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": "bulk_delete",
      "data": units,
      "requested_by": userWhoMadeRequest
    })
  }

  bulkMonitor(units: number[], userWhoMadeRequest: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'monitor',
      "data": units,
      "requested_by": userWhoMadeRequest
    })
  }

  bulkUnMonitor(units: number[], userWhoMadeRequest: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'unmonitor',
      "data": units,
      "requested_by": userWhoMadeRequest
    })
  }

  bulkProvision(units: number[], userWhoMadeRequest: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'provision_quick',
      "data": units,
      "requested_by": userWhoMadeRequest
    })
  }

  bulkUnProvision(units: number[], userWhoMadeRequest: string): Observable<any> {
    return this.http.post<any>(home.bulkActions, {
      "event": 'unprovision_quick',
      "data": units,
      "requested_by": userWhoMadeRequest
    })
  }

  pullAllUnitsConfigurationFiles(userWhoMadeRequest: string): Observable<any> {
    return this.http.post<{ data: any[] }>(system_manager.services, {
      "event": "pull_all_units_configuration_files",
      "requested_by": userWhoMadeRequest
    })
  }
}
